export default "__VITE_ASSET__10470bb9__"